import { lazy } from 'react';

// project import
import Loadable from 'components/Loadable';
import MinimalLayout from 'layout/MinimalLayout';

// render - login
const AuthSignUp = Loadable(lazy(() => import('pages/authentication/Signup')));
const VerifyEmail = Loadable(lazy(() => import('pages/authentication/VerifyEmail')));
const ConfirmEmailChange = Loadable(lazy(() => import('pages/settings/ConfirmEmailChange')));

// ==============================|| AUTH ROUTING ||============================== //

const SignupRoutes = {
    path: '/',
    element: <MinimalLayout />,
    children: [
        {
            path: 'signup',
            element: <AuthSignUp />
        },
        {
            path: 'verify/:uid/:token',
            element: <VerifyEmail />
        },
        {
            path: 'confirm-email-change/:token',
            element: <ConfirmEmailChange />
        }
    ]
};

export default SignupRoutes;
